// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel';

const { css } = require("jquery");
// html-to-image plugin
import * as htmlToImage from "html-to-image";

require("vanilla-js-wheel-zoom/dist/wheel-zoom.js");
// require("vanilla-js-wheel-zoom/dist/wheel-zoom.min.js");
$(function() {
    var accordin = document.getElementsByClassName("accordin");
    var i;

    const homeAd = document.querySelectorAll(".home-ad");
    const footer = document.querySelector(".footer");
    const homePageContent = document.querySelector(".center__contents");
    const firstDiv = document.querySelector(".home-page-mainContent > div");
    const genericPage = document.querySelector(".generic_page");
    const navbar = document.querySelector(".navbar");
    const treeUl = document.querySelector(".tree_ul");
    let navbarHeight = getComputedStyle(navbar).height;
    let navbarHeightNumber = Number(navbarHeight.split("p")[0]);
    let footerReached = false;
    let tallestAd = 0;
    let adTop = 0;
    let ptags;

    // const convertButton = document.getElementById("btn_convert1");
    // convertButton &&
    //     convertButton.addEventListener("click", function() {
    //         html2canvas(document.querySelector(".tree_ul")).then(function(
    //             canvas
    //         ) {
    //             var anchorTag = document.createElement("a");
    //             document.body.appendChild(anchorTag);
    //             document.getElementById("previewImg").appendChild(canvas);
    //             anchorTag.download = "filename.jpg";
    //             anchorTag.href = canvas.toDataURL();
    //             anchorTag.target = "_blank";
    //             anchorTag.click();
    //         });
    //     });

    const genericPara = document.querySelectorAll(".paragraph--content");
    genericPara &&
        genericPara.forEach(genericPara => {
            ptags = genericPara.querySelectorAll("p");
            ptags.forEach(p => {
                // textContent and innerHTML evaluates to " " one spacebar
                // but innerText evaluates to "" empty string
                if (p.innerText === "") p.classList.add("p-h-8");
            });
        });

    // Zoom in tree
    // treeUl.addEventListener('mousemove' ,function(e){
    //  const treeHeight = treeUl.offsetHeight;
    //  const treeWidth = treeUl.offsetWidth;
    //  let mouseX = e.offsetX;
    //  let mouseY = e.offsetY;
    //  console.log(`${mouseX} : ${mouseY}`);
    // });

    // if(treeUl){
    //  let scale = 1;
    //  treeUl.addEventListener('wheel', function(e){
    //    e.preventDefault();

    //     scale += event.deltaY * -0.01;

    //     // Restrict scale
    //     scale = Math.min(Math.max(.125, scale), 4);

    //     // Apply scale transform
    //     this.style.transform = `scale(${scale})`;
    //  });
    // }

    // Facebook comment full width fix starts
    // const iframeDiv = document.querySelector(".pd-left-rt");
    // const iframes = iframeDiv.getElementsByTagName("iframe");
    // const iframeObserver = new MutationObserver(function(mutations) {
    //     mutations.forEach(function(m) {
    //         if (m.addedNodes.length) {
    //             console.log("iframe added");
    //         }
    //     });
    // });

    // iframeObserver.observe(iframeDiv, { childList: true });

    // console.log("iframes");
    // console.log(iframes);

    // Facebook comment full width fix ends

    // STICKY NAVBAR BY OBSERVING THE NAVBAR ADVERTISEMENT
    const navbarAd = document.querySelector(".navbar_ad");

    const fixedNavbar = function(entries) {
        const [entry] = entries;
        if (entry.isIntersecting) {
            navbar.classList.remove("fixed_navbar");
            footerReached = false;
            stickyTopFix();
        } else {
            navbar.classList.add("fixed_navbar");
        }
    };

    const navbarAdObserver = new IntersectionObserver(fixedNavbar, {
        root: null,
        threshold: 0,
        rootMargin: "65px"
    });

    navbarAd && navbarAdObserver.observe(navbarAd);

    // STICKY NAVBAR BY OBSERVING THE NAVBAR ADVERTISEMENT

    const stickyTopFix = function() {
        const stickies = document.querySelectorAll(".sticky-ad");
        const winOff = window.pageYOffset;
        if (homePageContent) {
            const homeTop = homePageContent.getBoundingClientRect().top;
            const topValue = winOff + homeTop;
            stickies.forEach(function(s) {
                s.style.bottom = "unset";
                if (genericPage) {
                    console.log("generic page present");
                    const gPaddingTop = getComputedStyle(genericPage)
                        .paddingTop;
                    const gPaddingTopNumber = Number(gPaddingTop.split("p")[0]);
                    if (footerReached)
                        // s.style.top = `${topValue +
                        //     gPaddingTopNumber +
                        //     navbarHeightNumber}px`;
                        s.style.top = `${topValue + navbarHeightNumber}px`;
                    // else s.style.top = `${topValue + gPaddingTopNumber}px`;
                    else s.style.top = `${topValue}px`;
                    // else s.style.top = `${topValue}px`;
                } else {
                    if (footerReached)
                        s.style.top = `${topValue + navbarHeightNumber}px`;
                    else s.style.top = `${topValue}px`;
                }
            });
        }
    };

    // Media query using JS

    function mediaQuery(x) {
        const callback = function(entries) {
            const [entry] = entries;
            console.log("footer observer entry");
            console.log(entry);
            const stickies = document.querySelectorAll(".sticky-ad");
            if (!entry.isIntersecting) {
                stickyTopFix();
            } else {
                // footerReached = true;
                console.log(footerReached);
                stickies.forEach(function(s) {
                    s.style.bottom = `${footer.offsetHeight + 16}px`;
                    // s.style.bottom = '0px';
                    s.style.top = "unset";
                });
            }
        };

        // const adObserver = new IntersectionObserver(fixedAd, {root: null, threshold: 0});
        const footerObserver = new IntersectionObserver(callback, {
            root: null,
            threshold: 0,
            rootMargin: "-100px"
        });

        if (x.matches) {
            // Remove sticky-ad class for smaller screens
            homeAd.forEach(function(h) {
                h.classList.remove("sticky-ad");
                h.style.top = "unset";
                h.style.bottom = "unset";
            });
            footerObserver.unobserve(footer);
        } else {
            if (homePageContent) {
                homeAd.forEach(function(h) {
                    h.classList.add("sticky-ad");
                    const winOff = window.pageYOffset;
                    const homeTop = homePageContent.getBoundingClientRect().top;
                    console.log("windows offset and home top called once");
                    console.log("winoff", winOff, "homeTop", homeTop);

                    h.style.top = `${winOff + homeTop}px`;
                });
            }

            // Using Intersection observer to observe the footer

            footerObserver.observe(footer);
        }
    }

    var x = window.matchMedia("(max-width: 992px)");
    mediaQuery(x); // Call listener function at run time
    x.addListener(mediaQuery); // Attach listener function on state changes

    function mediaQueryLandscape(yTabLandscape) {
        if (yTabLandscape.matches) {
            stickyTopFix();
        } else {
            stickyTopFix();
        }
    }

    var yTabLandscape = window.matchMedia("(max-width: 1200px)");
    mediaQueryLandscape(yTabLandscape);
    yTabLandscape.addListener(mediaQueryLandscape);

    // Making ADS sticky using scroll event

    // Making ADS sticky using scroll event

    for (i = 0; i < accordin.length; i++) {
        accordin[i].addEventListener("click", function() {
            this.classList.toggle("active-accordin");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    jQuery(function() {
        let tagName;
        let tag;
        let buttons = document.querySelectorAll(".button");
        for (i = 0; i < buttons.length; i++) {
            tag = buttons[i].parentElement;
            tagName = buttons[i].parentElement.tagName;
            if (!tag.classList.contains("u-right-text")) {
                // console.log('hey');
                tag.classList.add("align-button-right");
            }
        }
    });

    // TREE ZOOM IN AND ZOOM OUT STARTS

    //tree_ul--rootLink should be scaled
    let zoomLevel = 1;
    let zoomChange = 0.2;
    const zoomUpperLimit = 1.2;
    const zoomLowerLimit = 0.4;
    // let zoomValue = 0;
    const zoomTarget = document.querySelector(".tree_ul--rootLink");
    console.log(zoomTarget);
    const tree_zoom = document.querySelector(".tree_zoom");
    tree_zoom &&
        tree_zoom.addEventListener("click", function(e) {
            const target = e.target.closest(".tree_zoom-button");
            if (target.classList.contains("tree_zoom-inc")) {
                if (zoomLevel >= zoomUpperLimit) return;
                zoomLevel += zoomChange;
                zoomTarget.style.transform = `scale(${zoomLevel.toFixed(2)})`;
                console.log(`scale(${zoomLevel.toFixed(2)})`);
            }
            if (target.classList.contains("tree_zoom-dec")) {
                if (zoomLevel < zoomLowerLimit) return;
                zoomLevel -= zoomChange;
                zoomTarget.style.transform = `scale(${zoomLevel.toFixed(2)})`;
                console.log(`scale(${zoomLevel.toFixed(2)})`);
            }
            if (target.classList.contains("tree_zoom-revert")) {
                zoomLevel = 1;
                zoomTarget.style.transform = "scale(1)";
            }
        });

    // TREE ZOOM IN AND ZOOM OUT ENDS

    // VANILLA JS WHEEL ZOOM

    document.addEventListener("DOMContentLoaded", function() {
        WZoom.create(".myContent", {
            type: "html",
            minScale: 1,
            maxScale: 4
            // width: 25000,
            // height: 15000
        });

        // FB.Event.subscribe("xfbml.render", function(response) {
        //     console.log("facebook plugin rendered.... finally!");
        // });
        // Fix facebook comments plugin width problem
        let iframeInterval = setInterval(() => {
            const iframeContainer = document.querySelector(".fb_iframe-box");
            if (iframeContainer) {
                const iframe = iframeContainer.querySelectorAll("iframe");
                iframe.forEach(i => {
                    if (i.classList.contains("iframe_full"))
                        clearInterval(iframeInterval);
                });
                iframe.forEach(i => {
                    i.classList.add("iframe_full");
                });
                console.log(iframe);
            }
        }, 2000);
        iframeInterval;
        // setTimeout(() => {
        //     const iframeContainer = document.querySelector(".fb_iframe-box");
        //     if (iframeContainer) {
        //         const iframe = iframeContainer.querySelectorAll("iframe");
        //         iframe.forEach(i => {
        //             i.classList.add("iframe_full");
        //         });
        //         console.log(iframe);
        //     }
        // }, 6000);
    });

    // ZOOMOOZ ZOOMING
    // $(document).ready(function() {
    //     $(".tree_ul-link").click(function(evt) {
    //         $(this).zoomTo({targetsize:0.2, duration:600, animationendcallback: true, closeclick: false});
    //         evt.stopPropagation();
    //     });
    // });

    // AD SLIDER LEFT

    const itemsLeft = document.querySelectorAll(".home-ad-carousel-items-left");
    let curSlideLeft = 0;
    const goToSlideLeft = function(slide) {
        itemsLeft.forEach(
            (s, i) => (s.style.transform = `translateY(${(i - slide) * 100}%)`)
        );
        // console.log(`curSlide value is ${curSlide}`);
    };

    let increaseLeft = true;

    goToSlideLeft(curSlideLeft);

    setInterval(function() {
        if (!itemsLeft) return;
        if (itemsLeft.length === 2) return;
        if (itemsLeft.length - curSlideLeft === 2) increaseLeft = false;
        if (increaseLeft) {
            curSlideLeft++;
            goToSlideLeft(curSlideLeft);
        }
        if (!increaseLeft) {
            curSlideLeft--;
            goToSlideLeft(curSlideLeft);
            if (curSlideLeft === 0) {
                increaseLeft = true;
                return;
            }
        }
    }, 5000);

    // AD SLIDER LEFT

    // AD SLIDER RIGHT

    const itemsRight = document.querySelectorAll(
        ".home-ad-carousel-items-right"
    );
    let curSlideRight = 0;
    const goToSlideRight = function(slide) {
        itemsRight.forEach(
            (s, i) => (s.style.transform = `translateY(${(i - slide) * 100}%)`)
        );
        // console.log(`curSlide value is ${curSlide}`);
    };

    let increaseRight = true;

    goToSlideRight(curSlideRight);

    setInterval(function() {
        if (!itemsRight) return;
        if (itemsRight.length === 2) return;
        if (itemsRight.length - curSlideRight === 2) increaseRight = false;
        if (increaseRight) {
            curSlideRight++;
            goToSlideRight(curSlideRight);
        }
        if (!increaseRight) {
            curSlideRight--;
            goToSlideRight(curSlideRight);
            if (curSlideRight === 0) {
                increaseRight = true;
                return;
            }
        }
    }, 5000);

    // AD SLIDER RIGHT

    // sliderInc.addEventListener("click", function() {
    //     if (items.length - curSlide === 2) return;
    //     curSlide++;
    //     console.log("curslide from increase", curSlide);
    //     goToSlide(curSlide);
    // });

    // sliderDec.addEventListener("click", function() {
    //     if (curSlide === 0) return;
    //     curSlide--;
    //     console.log("curslide from decrease", curSlide);
    //     goToSlide(curSlide);
    // });

    const carouselHeightFix = function() {
        const carousels = document.querySelectorAll(".home-ad-carousels");
        carousels.forEach(c => {
            const carousel = c.querySelector(".home-ad-carousel-items");
            const height = carousel.clientHeight;
            console.log(height);
            c.style.height = `${height * 2}px`;
        });
    };

    carouselHeightFix();

    $(window).resize(function() {
        carouselHeightFix();
    });
    // const resizeAllModals = document.querySelectorAll(".modal_custom");
    // resizeAllModals.forEach(function(m) {
    //     if (!m.classList.contains("hidden")) {
    //         const roomsSlider = m.querySelector(".rooms_slider");
    //         const roomsSliderSlideHeight = roomsSlider.querySelector(
    //             ".rooms_slider-slide"
    //         ).offsetHeight;
    //         console.log("--resizing and fixing height --");
    //         console.log(roomsSliderSlideHeight);
    //         roomsSlider.style.height = `${roomsSliderSlideHeight}px`;
    //     }
    // });
    // });

    // FIXING ONECHILD ISSUES USING JQUERY STARTS
    console.log("FIXING ONECHILD USING JQUERY BY SELECTING THE ONDECHILDS");
    // let $oneChilds = $("ul.oneChild");
    // $oneChilds.each(function() {
    //     if (
    //         !$(this)
    //             .parent()
    //             .hasClass("tree_ul--rootLink")
    //     ) {
    //         console.log(
    //             $(this)
    //                 .children()
    //                 .find("> .tree_ul-link")
    //         );
    //         let $toShift = $(this)
    //             .children()
    //             .find("> .tree_ul-link")
    //             .position().left;
    //         console.log($toShift);
    //         // $(this).css("transform", `translateX(-${$toShift}px)`);
    //     }
    // });
    console.log(
        "FIXING ONECHILD USING JQUERY BY ITERATING OVER LI.TREE_HASONECHILD"
    );
    let $liOneChilds = $("li.tree_hasOneChild");
    // Found the following in stack overflow which helps to iterate in a reverse way over jquery object
    // $($("li").get().reverse()).each(function() { /* ... */ });
    // console.log($liOneChilds);
    $($liOneChilds.get().reverse()).each(function() {
        // Checking if this li.tree_hasOneChild is the first child
        if (
            $(this).is(":first-child") &&
            !$(this).hasClass("tree_ul--rootLink")
        ) {
            $(this).addClass("tree_hasOneChildFirstChild");
        }
        // Check if this is the tree_ul--rootLink or not and proceed forward only if
        // this is not the rootLink
        if (!$(this).hasClass("tree_ul--rootLink")) {
            let $treeLink = $(this).find("> .oneChild > li > .tree_ul-link");
            let $treeLinkPositionLeft = $treeLink.position().left;
            let $treeLinkToPosition = $(this).find("> .tree_ul-link");
            let $treeLinkToPositionOffsetLeft = $treeLinkToPosition.offset()
                .left;
            let $newOffsetLeft =
                $treeLinkToPositionOffsetLeft + $treeLinkPositionLeft;
            $treeLinkToPosition.offset({ left: $newOffsetLeft });
        } else {
        }
    });
    // FIXING ONECHILD ISSUES USING JQUERY ENDS
    // CALCULATING OFFSETS NPCUSTOM STARTS
    var offset = parseInt(
        $("#parentLi").outerWidth() * 0.5 - $(window).width() * 0.5 + 105
    ); //$('#parentLi > .tree_ul-link').outerWidth()*.5+5);
    console.log(offset);
    $("#genTree").kinetic({
        filterTarget: function(target, e) {
            if (!/down|start/.test(e.type)) {
                return !/area|a|input/i.test(target.tagName);
            }
        },
        y: false
    });
    if ($("#genTree #parentLi").outerWidth() < $(window).width()) {
        $("#genTree").addClass("centered");
        const testElement = document.querySelector(
            "#genTree .tree_ul--rootLink > .oneChild"
        );

        if (!(testElement === null)) {
            const oneChildElement = document.querySelector(
                ".tree_hasOneChild > .tree_hasChild-link"
            );
            const childrenElement = document.querySelector(
                "#genTree .tree_ul--rootLink > .oneChild .tree_ul-link"
            );
            const oneChildCoords = document
                .querySelector(".tree_hasOneChild > .tree_hasChild-link")
                .getBoundingClientRect();
            const childrenCoords = document
                .querySelector(
                    "#genTree .tree_ul--rootLink > .oneChild .tree_ul-link"
                )
                .getBoundingClientRect();
            console.log("logging the elements");
            console.log(oneChildElement, childrenElement);
            const offset3 = oneChildCoords.x - childrenCoords.x;
            console.log(oneChildCoords, childrenCoords, offset3);
            console.log(`Offset 3 is ${offset3}`);
            $("#genTree .tree_ul--rootLink > .oneChild").css("left", offset3);
            const oneChildCoords1 = document
                .querySelector(".tree_hasOneChild > .tree_hasChild-link")
                .getBoundingClientRect();
            const childrenCoords1 = document
                .querySelector(
                    "#genTree .tree_ul--rootLink > .oneChild .tree_ul-link"
                )
                .getBoundingClientRect();
            const offset4 = oneChildCoords1.x - childrenCoords1.x;
            console.log(`difference is ${offset3 - offset4}`);
        }
    } else {
        $("#genTree").kinetic("scrollLeft", offset);
        var offset2 = parseInt(
            $(
                "#genTree .tree_ul--rootLink > .oneChild .tree_ul-link"
            ).outerWidth() *
                0.5 +
                8
        );
        console.log(`ul is offsetted by ${offset2}`);
        console.log(`offset2 is ${offset2}`);
        $("#genTree .tree_ul--rootLink > .oneChild").css("left", offset2);
    }

    // MOUSEENTER EVENTS FOR SUB GENEALOGIES STARTS
    $(".navbar__list-item--mega").on("mouseover", function() {});
    $(".dropdown__link-subgen").on("mouseenter", function(e) {
        const targetId = $(this).attr("data-target");
        const targetDropdown = $(`#${targetId}`);
        // console.log(e.currentTarget);
        targetDropdown.addClass("dropdown_side-active");
        // console.log("offset of dropdown__link-subgen is ", $(this).offset());
        // console.log("offset of dropdown_side is ", targetDropdown.offset());
        targetDropdown.offset({ top: $(this).offset().top });
        // $(".dropdown__link-subgenTitle").css("background-color", "#ce6b65");
    });

    $(".dropdown__link-subgen").on("mouseleave", function() {
        const targetId = $(this).attr("data-target");
        $(`#${targetId}`).removeClass("dropdown_side-active");
        $(".dropdown__link-subgenTitle").css("background-color", "unset");
    });

    $(".dropdown_side").on("mouseenter", function() {
        $(this).addClass("dropdown_side-active");
        const targetId = $(this).attr("id");
        const dataTarget = targetId.split("#");
        // console.log(targetId.split("#"));
        // console.log("logging the subgen by selecting using data target", $([data-target=``]));
        console.log($(`[data-target=${dataTarget}]`));
        $(`[data-target=${dataTarget}]`).css("background-color", "#ce6b65");
        // $(".dropdown__link-subgenTitle").css("background-color", "#ce6b65");
    });

    $(".dropdown_side").on("mouseleave", function() {
        $(this).removeClass("dropdown_side-active");
        const targetId = $(this).attr("id");
        const dataTarget = targetId.split("#");
        $(`[data-target=${dataTarget}]`).css("background-color", "unset");
        // $(".dropdown__link-subgenTitle").css("background-color", "unset");
    });
    // MOUSEENTER EVENTS FOR SUB GENEALOGIES ENDS

    // CALCULATING OFFSETS NPCUSTOM STARTS

    // // FIXING ONECHILD ISSUES USING VANILLA JS STARTS
    // // GETTING ALL THE li.tree_hasOneChild elements
    // const liNodeList = document.querySelectorAll(".tree_hasOneChild");
    // // liNodeList.forEach(l => console.log(l.nextElementSibling));

    // // Converting the liNodeList to an array
    // let liArrayList = [];
    // for (let i = 0; i < liNodeList.length; i++) {
    //     liArrayList.push(liNodeList[i]);
    // }

    // // console.log(liArrayList);

    // // directChildArray holds the immediate child elements of li.tree_hasOneChild
    // let directChildArray = [];
    // let oneChildArrayContainer = [];
    // let liArrayParents = [];
    // console.log("liArrayList", liArrayList);
    // liArrayList.forEach((l, i) => {
    //     if (l.parentNode.classList.contains("oneChild")) {
    //         console.log("this hasChild is a child", l);
    //         l.classList.add("tree_hasOneChild-child");
    //     } else {
    //         console.log("this hasChild is a parent", l);
    //         l.classList.add("tree_hasOneChild-parent");
    //         liArrayParents.push(l);
    //     }
    //     const childrenArray = [];
    //     const children = l.children;
    //     const oneChildArray = [];
    //     for (let i = 0; i < children.length; i++) {
    //         childrenArray.push(children[i]);
    //     }
    //     if (childrenArray) {
    //         childrenArray.forEach(c => directChildArray.push(c));
    //     }
    //     if (childrenArray) {
    //         childrenArray.forEach(c => {
    //             if (c.classList.contains("oneChild")) oneChildArray.push(c);
    //         });
    //     }
    //     oneChildArrayContainer.push(oneChildArray);
    // });

    // // console.log("parents li list", liArrayParents);
    // // Code to fix the one child problem

    // liArrayParents.forEach(l => {
    //     let toCopyTreeLink;
    //     let toShiftTreeLink;
    //     // console.log("this is a parent", l);
    //     // Get all the ul.oneChild elements and store them in a nodelist
    //     const oneChildList = l.querySelectorAll(".oneChild");
    //     const childrenArray = [];

    //     for (let i = 0; i < oneChildList.length; i++) {
    //         childrenArray.push(oneChildList[i]);
    //     }
    //     // We reverse the array containing the children so that we access the last oneChild in the beginning
    //     childrenArray.reverse();
    //     console.log("childrenArray", childrenArray);

    //     // Now we have to loop through the children array and find the difference between
    //     // getBoundingClientRect().x of this oneChild > tree_hasChild > tree_ul-link and shift the next element by
    //     // we loop till the second last element in the children array
    //     // this solves the kalman case
    //     if (childrenArray.length >= 2) {
    //         // console.log("child array length", childrenArray.length);
    //         for (let i = 0; i < childrenArray.length - 1; i++) {
    //             // console.log("this is loop counter", i);
    //             const targetElement = childrenArray[i].querySelector(
    //                 ".tree_hasChild > .tree_ul-link"
    //             );
    //             if (!targetElement) continue;
    //             const targetElement_x = targetElement.getBoundingClientRect().x;

    //             const toShiftElement = childrenArray[i + 1].querySelector(
    //                 ".tree_hasChild > .tree_ul-link"
    //             );
    //             const toShiftElement_x = toShiftElement.getBoundingClientRect()
    //                 .x;
    //             // console.log(
    //             //     "target element and to shift element",
    //             //     targetElement,
    //             //     toShiftElement
    //             // );
    //             toShiftElement.style.left = `${targetElement_x -
    //                 toShiftElement_x}px`;
    //             // Adding border to check which element's left value changed
    //             // toShiftElement.style.border = "1px solid red";
    //             if (i === childrenArray.length - 2) {
    //                 console.log("last target element", targetElement);
    //                 toCopyTreeLink = targetElement;
    //             }
    //         }
    //         console.log("toCopyTreeLink", toCopyTreeLink);
    //         const immediateChildren = l.children;
    //         let immediateChildrenArray = [];
    //         for (let i = 0; i < immediateChildren.length; i++) {
    //             immediateChildrenArray.push(immediateChildren[i]);
    //         }

    //         immediateChildrenArray.forEach(c => {
    //             // console.log("im an immediate child", c);
    //             if (c.classList.contains("tree_ul-link")) toShiftTreeLink = c;
    //         });

    //         const toCopyTreeLink_x = toCopyTreeLink.getBoundingClientRect().x;
    //         const toShiftTreeLink_x = toShiftTreeLink.getBoundingClientRect().x;

    //         toShiftTreeLink.style.left = `${toCopyTreeLink_x -
    //             toShiftTreeLink_x}px`;
    //     }
    //     // Now we get the tree_ul-link which is direct child of aParent and shift is using toCopyX variable
    //     // This solved dhanman case
    //     if (childrenArray.length < 2) {
    //         console.log(
    //             "children array length is less than 2 and is equal to ",
    //             childrenArray.length
    //         );
    //         const immediateChildren = l.children;
    //         let immediateChildrenArray = [];
    //         for (let i = 0; i < immediateChildren.length; i++) {
    //             immediateChildrenArray.push(immediateChildren[i]);
    //         }

    //         immediateChildrenArray.forEach(c => {
    //             // console.log("im an immediate child", c);
    //             if (c.classList.contains("oneChild")) {
    //                 toCopyTreeLink = c.querySelector(
    //                     ".tree_hasChild > .tree_ul-link"
    //                 );
    //             }
    //             if (c.classList.contains("tree_ul-link")) {
    //                 toShiftTreeLink = c;
    //             }
    //         });

    //         // Check of toCopyTreeLink exists, it may not exist since the last tree_link may be the node who
    //         // doesnt have any child
    //         if (toCopyTreeLink) {
    //             const toCopyTreeLink_x = toCopyTreeLink.getBoundingClientRect()
    //                 .x;
    //             const toShiftTreeLink_x = toShiftTreeLink.getBoundingClientRect()
    //                 .x;
    //             console.log(
    //                 "to copy tree link and its x value are ",
    //                 toCopyTreeLink,
    //                 toCopyTreeLink_x
    //             );
    //             toShiftTreeLink.style.left = `${toCopyTreeLink_x -
    //                 toShiftTreeLink_x}px`;
    //         }
    //     }
    //     console.log("to shift tree link is ", toShiftTreeLink);
    // });
    // // FIXING ONECHILD ISSUES USING VANILLA JS ENDS

    // // reversing the oneChildArrayContainer
    // oneChildArrayContainer.reverse();

    // console.log("one child array container", oneChildArrayContainer);

    // console.log("one child array container is ", oneChildArrayContainer);
    // console.log("direct child array is", directChildArray);
    // Using filter to filter the direct child containing only the oneChild class
    // oneChildArray = directChildArray.filter(d => d.classList.contains("oneChild"));
    // console.log("one child array is", oneChildArray);

    // Since we need to calculate the offset from the last oneChild element we need to reverse the oneChildArray
    // oneChildArray.reverse();
    // console.log("reveresed onechild array is ", oneChildArray);

    // Checking if there are more than or equal to two ul.oneChild elements
    // if (oneChildArray.length >= 2) {
    //     for (let i = 0; i < oneChildArray.length - 1; i++) {
    //         const targetElement = oneChildArray[i].querySelector(
    //             ".tree_hasChild > .tree_ul-link"
    //         );
    //         const targetElement_x = targetElement.getBoundingClientRect().x;

    //         const toShiftElement = oneChildArray[i + 1].querySelector(
    //             ".tree_hasChild > .tree_ul-link"
    //         );
    //         const toShiftElement_x = toShiftElement.getBoundingClientRect().x;
    //         console.log(
    //             "target element and to shift element",
    //             targetElement,
    //             toShiftElement
    //         );
    //         toShiftElement.style.left = `${targetElement_x - toShiftElement_x}px`;
    //     }
    // }

    // liLastChildList is an array containing all li.tree_hasOneChild as last child
    // If ul.oneChild is immediate child of an item of liLastChildList then li.tree_hasOneChild > .tree_ul-link should be shifted to the left by sth px
    // sth px is given calculated by using getBoundingClientRect() of ul.oneChild > .tree_hasChild > .tree_ul-link
    // liLastChildList = liArrayList.filter(l => l.nextElementSibling === null);

    // console.log(liLastChildList);
    // liLastChildList.forEach(l => {
    //     if (l.querySelector(".oneChild") && !l.getAttribute("id")) {
    //         // console.log("id attribute", l.getAttribute("id"));
    //         const oneChild = l.querySelector(".oneChild");
    //         // const toShiftElement =
    //         const targetElement = oneChild.querySelector(
    //             ".tree_hasChild > .tree_ul-link"
    //         );
    //         // Check if targetElement is null or not
    //         if (targetElement) {
    //             const targetElement_x = targetElement.getBoundingClientRect().x;
    //             console.log(targetElement_x);

    //             const toShiftElement = oneChild.previousElementSibling;
    //             const toShiftElement_x = toShiftElement.getBoundingClientRect().x;
    //             toShiftElement.style.left = `${targetElement_x -
    //                 toShiftElement_x}px`;
    //         }
    //     }
    // });
});
